
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 156 141","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.573 17.146A8.573 8.573 0 108.573 0a8.573 8.573 0 000 17.146zM29.148 2.363a6.21 6.21 0 000 12.42h95.447a6.211 6.211 0 100-12.42H29.148zM17.146 69.728a8.573 8.573 0 11-17.146 0 8.573 8.573 0 0117.146 0zM8.573 140.027a8.573 8.573 0 100-17.146 8.573 8.573 0 100 17.146zM17.146 100.591A8.574 8.574 0 110 100.59a8.574 8.574 0 0117.147.001zM29.148 32.655a6.21 6.21 0 100 12.42h95.447a6.211 6.211 0 100-12.42H29.148zM17.146 38.865a8.573 8.573 0 11-17.146 0 8.573 8.573 0 0117.146 0zM90 130.823c0-1.885.154-3.752.451-5.58H29.148a6.21 6.21 0 000 12.421H90v-6.841zM106.79 102.066a26.672 26.672 0 01-5.803-7.438l-71.839.752c-3.43.036-6.21 2.846-6.21 6.276 0 3.43 2.78 6.181 6.21 6.145l70.552-.739c2.088-2.027 4.466-3.725 7.09-4.996zM98.834 75.938c1.245-4.797 3.824-9.072 7.327-12.42H29.148a6.21 6.21 0 000 12.42h69.686z"}}),_c('path',{attrs:{"d":"M135.143 102.561c7.3-3.769 12.29-11.385 12.29-20.166 0-12.527-10.155-22.682-22.682-22.682-12.526 0-22.681 10.155-22.681 22.682 0 8.745 4.949 16.335 12.2 20.12-11.819 4.251-20.27 15.56-20.27 28.842v8.397h61.285v-8.397c0-13.234-8.39-24.509-20.142-28.796z"}})])
          )
        }
      }
    